export default function logicGraphDataActions(logic) {
    return dispatch => {
        dispatch({
            type:'GET_LOGIC_GRAPH_DATA',
            payload:logic
        });
    }
}
